import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { FormlyDesignerComponent } from './formly-designer/formly-designer.component';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyKendoModule } from '@ngx-formly/kendo';
import { FormlySelectModule } from '@ngx-formly/core/select';
import { FormlyFieldInputComponent } from './formly-field/formly-field-input/formly-field-input.component';
import { FormlyValidationLoader } from './formly-validation-loader';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormControl, ValidationErrors } from '@angular/forms';
import { FormlyFieldTextAreaComponent } from './formly-field/formly-field-text-area/formly-field-text-area.component';
import { FormlyFieldCheckboxComponent } from './formly-field/formly-field-checkbox/formly-field-checkbox.component';
import { FormlyFieldSelectComponent } from './formly-field/formly-field-select/formly-field-select.component';
import { FormlyFieldRadioComponent } from './formly-field/formly-field-radio/formly-field-radio.component';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { FormlyDesignerFieldEditComponent } from './formly-designer/formly-designer-field-edit/formly-designer-field-edit.component';
import { FormlyWrapperHorizontalComponent } from './formly-wrapper/formly-wrapper-horizontal/formly-wrapper-horizontal.component';
import { FormlyFieldMultiCheckboxComponent } from './formly-field/formly-field-multi-checkbox/formly-field-multi-checkbox.component';
import { FormlyFieldDateComponent } from './formly-field/formly-field-date/formly-field-date.component';
import { FormlyDesignerFlagEditComponent } from './formly-designer/formly-designer-flag-edit/formly-designer-flag-edit.component';
import { FormlyDesignerRuleEditComponent } from './formly-designer/formly-designer-rule-edit/formly-designer-rule-edit.component';
import { FormlyDesignerTaskEditComponent } from './formly-designer/formly-designer-task-edit/formly-designer-task-edit.component';
import { FormlyDesignerServiceTypeEditComponent }
    from './formly-designer/formly-designer-service-type-edit/formly-designer-service-type-edit.component';
import { FormlyDesignerChannelEditComponent } from './formly-designer/formly-designer-channel-edit/formly-designer-channel-edit.component';
import { FormlyDesignerNeedEditComponent } from './formly-designer/formly-designer-need-edit/formly-designer-need-edit.component';
import { FormlyDesignerSummaryComponent } from './formly-designer/formly-designer-summary/formly-designer-summary.component';
import { QueryBuilderLocalizationService } from '../shared/query-builder/query-builder-localization.service';
import { FormlyRuleNarrativePipe } from './formly-designer/formly-designer-summary/formly-designer-rule-narrative.pipe';
import { FormlyFieldTabComponent } from './formly-field/formly-field-tab/formly-field-tab.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { FormlyFieldLabelComponent } from './formly-field/formly-field-label/formly-field-label.component';
import { FormlyFieldDateTimeComponent } from './formly-field/formly-field-date-time/formly-field-date-time.component';
import { FormlyFieldMultiSelectComponent } from './formly-field/formly-field-multi-select/formly-field-multi-select.component';
import { DocumentModule } from '../document/document.module';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { MemberListService } from '../core/service/grid-data/grid-data-member.service';

export function emailValidator(control: UntypedFormControl): ValidationErrors
{
    // W3C Email RegEx
    return !control.value ||
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(control.value) ? null : { email: true };
}

@NgModule({
    declarations: [
        FormlyDesignerComponent,
        FormlyFieldInputComponent,
        FormlyFieldTextAreaComponent,
        FormlyFieldCheckboxComponent,
        FormlyFieldSelectComponent,
        FormlyFieldRadioComponent,
        FormlyDesignerFieldEditComponent,
        FormlyWrapperHorizontalComponent,
        FormlyFieldMultiCheckboxComponent,
        FormlyFieldDateComponent,
        FormlyFieldDateTimeComponent,
        FormlyDesignerFlagEditComponent,
        FormlyDesignerRuleEditComponent,
        FormlyDesignerTaskEditComponent,
        FormlyDesignerServiceTypeEditComponent,
        FormlyDesignerChannelEditComponent,
        FormlyDesignerNeedEditComponent,
        FormlyDesignerSummaryComponent,
        FormlyRuleNarrativePipe,
        FormlyFieldTabComponent,
        FormlyFieldLabelComponent,
        FormlyFieldDateTimeComponent,
        FormlyFieldMultiSelectComponent
    ],
    imports: [
        SharedModule,
        SortableModule,
        FormlyModule.forRoot({
            validators: [
                { name: 'email', validation: emailValidator }
            ],
            wrappers: [{ name: 'form-field-horizontal', component: FormlyWrapperHorizontalComponent }],
            types: [
                { name: 'input', component: FormlyFieldInputComponent },
                { name: 'textarea', component: FormlyFieldTextAreaComponent },
                { name: 'checkbox', component: FormlyFieldCheckboxComponent },
                { name: 'select', component: FormlyFieldSelectComponent },
                { name: 'multiselect', component: FormlyFieldMultiSelectComponent },
                { name: 'radio', component: FormlyFieldRadioComponent },
                { name: 'multicheckbox', component: FormlyFieldMultiCheckboxComponent },
                { name: 'date', component: FormlyFieldDateComponent },
                { name: 'tabs', component: FormlyFieldTabComponent },
                { name: 'label', component: FormlyFieldLabelComponent },
                { name: 'datetime', component: FormlyFieldDateTimeComponent },
            ]
        }),
        FormlySelectModule,
        FormlyKendoModule,
        EditorModule,
        DocumentModule,
        MonacoEditorModule,
        NgxJsonViewerModule
    ],
    exports: [
        FormlyDesignerComponent,
        FormlyFieldInputComponent,
        FormlyFieldTextAreaComponent,
        FormlyFieldCheckboxComponent,
        FormlyFieldSelectComponent,
        FormlyFieldRadioComponent,
        FormlyDesignerFieldEditComponent,
        FormlyWrapperHorizontalComponent,
        FormlyFieldMultiCheckboxComponent,
        FormlyFieldDateComponent,
        FormlyFieldDateTimeComponent,
        FormlyFieldTabComponent,
        FormlyFieldLabelComponent,
        FormlyFieldMultiSelectComponent,
    ],
    providers: [
        TranslateService,
        FormlyValidationLoader,
        QueryBuilderLocalizationService,
        FormlyRuleNarrativePipe,
        MemberListService
    ]
})
export class FormlyCustomModule { }
